import type { SupportSubcategoryQuestion } from './types';

export function isQuestionVisible(q: SupportSubcategoryQuestion, answers: Record<string, string>): boolean {
  if (!q.visibleWhen) return true;
  return answers[q.visibleWhen.questionId] === q.visibleWhen.value;
}
